import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaListAlt, FaCheck, FaPlus } from 'react-icons/fa';
import '../styles/BottomNav.css';

export default function BottomNav() {
  const location = useLocation();

  const isActive = path => location.pathname === path;

  return (
    <nav className="bottom-nav">
      <Link to="/" className={isActive('/') ? 'active' : ''}>
        <FaListAlt />
      </Link>
      <Link to="/lunas" className={isActive('/lunas') ? 'active' : ''}>
        <FaCheck />
      </Link>
      <Link to="/tambah" className={isActive('/tambah') ? 'active' : ''}>
        <FaPlus />
      </Link>
    </nav>
  );
}
